export class UserAlreadyExistsException {}